import { Close } from "@mui/icons-material";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import { Grid, IconButton, InputAdornment, TextField } from "@mui/material";
import Picker from "emoji-picker-react";
import { React, useEffect, useState } from "react";
import { useSelector } from "react-redux";

function TextFieldUsername(processText, signupDisabled) {
    const { registerErrors } = useSelector((state) => state.auth);
    const { currentUser } = useSelector((state) => state.auth);
    const perpetualUser = useSelector((state) => state.dashboard.boards);

    const [textValue, setTextValue] = useState("");
    const [showPass, setShowPass] = useState(false);

    const setShow = () => setShowPass((value) => !value);

    const onEmojiClick = (event, emojiObject) => {
        setTextValue(textValue + emojiObject.emoji);
        processText("username", textValue + emojiObject.emoji);
    };

    function updateValue(value) {
        setTextValue(value);
        processText("username", value);
    }

    useEffect(() => {
        if (currentUser !== null && currentUser !== undefined) {
            setTextValue(currentUser.username);
        }
    }, [currentUser, perpetualUser]);

    return (
        <Grid container style={{ textAlign: "-webkit-center" }}>
            <Grid item xs={12} style={{ margin: "10px" }}>
                <TextField
                    error={
                        registerErrors && registerErrors.username !== null
                            ? registerErrors.username
                            : null
                    }
                    helperText={
                        registerErrors && registerErrors.username !== null
                            ? registerErrors.username
                            : null
                    }
                    id="outlined-username-input"
                    label="Username"
                    type="text"
                    autoComplete="username"
                    onChange={(e) => updateValue(e.target.value)}
                    value={textValue}
                    disabled={signupDisabled}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle username visibility"
                                    onClick={setShow}
                                    edge="end"
                                >
                                    {showPass ? (
                                        <Close />
                                    ) : (
                                        <SentimentSatisfiedAltIcon />
                                    )}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                {showPass ? <Picker onEmojiClick={onEmojiClick} /> : null}
            </Grid>
        </Grid>
    );
}

export default TextFieldUsername;
